export default __webpack_public_path__ + "static/media/share.40a08411.svg";